module.exports = __webpack_public_path__ + "static/media/webdesign-services-img22.3ff27438.jpg";